import { useMutation } from "react-query";
import { linkStudyToReport, uploadReport } from "@/services/report";
/** Mutation hook that uploads a free-text report for a patient. */
export function useUploadReport(workspaceId, patientUid) {
  return useMutation(function (report) {
    return uploadReport(workspaceId, patientUid, report);
  });
}

/** Mutation hook that links an uploaded report to a study. */
export function useLinkStudyToReport(workspaceId, patientUid) {
  return useMutation(function (_ref) {
    var reportId = _ref.reportId,
      accessionNumber = _ref.accessionNumber;
    return linkStudyToReport(workspaceId, patientUid, reportId, accessionNumber);
  });
}